import { Component, OnInit } from '@angular/core';
import { SuperadminService } from 'src/app/services/superadmin/superadmin.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import * as moment from 'moment'

@Component({
  selector: 'app-session',
  templateUrl: './session.component.html',
  styleUrls: ['./session.component.css']
})
export class SessionComponent implements OnInit {


  Submitted: boolean = false;
  UserIDMsg:any;
  BranchList: any;
  SessionList:any; 

  constructor(private superadminservice: SuperadminService, private lookupservice: LookupService,
    private globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  SessionModel = {
    LogoPath: '',
    SessionID: 0,
    Session: '',
    SessionStartDate: '',
    SessionEndDate: '',
    SessionStatus: '0',
    IsActive: false,
    BranchID: 0
  };

  Clear() {
    this.SessionModel.LogoPath = '';
    this.SessionModel.Session = '';
    this.SessionModel.SessionStartDate = '';
    this.SessionModel.SessionEndDate = '';
    this.SessionModel.SessionStatus = '0';
    this.Submitted = false;   

  };


  GetSession() {
    this.spinnerService.show();
    this.superadminservice.GetSession(this.SessionModel.BranchID).subscribe((response: any) => {
      this.SessionList = response.SessionList;
      this.spinnerService.hide();

    });
  };

  SessionMarkActive(obj) {
    this.Clear();
    this.SessionModel.SessionID = obj.SessionID;
    this.SessionModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.superadminservice.SessionMarkActive(JSON.stringify(this.SessionModel)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.GetSession();
      this.globalHelper.CheckActionStatus(response);

    });
  }

  validationDropDown() {
    return this.SessionModel.BranchID == 0 ;
  }

 
  SaveSession(valid) {

    this.Submitted = true;
    if (valid && !this.validationDropDown()) {
      this.spinnerService.show();
      this.SessionModel.SessionStartDate = this.SessionModel.SessionStartDate != null && this.SessionModel.SessionStartDate != '' ? moment(this.SessionModel.SessionStartDate).format('DD-MMM-YYYY') : '';
      this.SessionModel.SessionEndDate = this.SessionModel.SessionEndDate != null && this.SessionModel.SessionEndDate != '' ? moment(this.SessionModel.SessionEndDate).format('DD-MMM-YYYY') : '';
      this.superadminservice.SaveSession(JSON.stringify(this.SessionModel)).subscribe((response: any) => {
        this.spinnerService.hide();
        if (response.webResponse.Status && this.SessionModel.SessionID==0) {
          this.Clear();
      }
      if (response.webResponse.Status) {
          this.GetSession();         
      }
     
        this.globalHelper.CheckActionStatus(response)
      });
    }
  };


  Edit(obj) {
   this.SessionModel.SessionID = obj.SessionID;
   this.SessionModel.BranchID = obj.BranchID;
   this.SessionModel.Session = obj.Session;
   this.SessionModel.SessionStartDate = moment(obj.SessionStartDate).format('DD-MMM-YYYY');
   this.SessionModel.SessionEndDate = moment(obj.SessionEndDate).format('DD-MMM-YYYY');
   this.SessionModel.SessionStatus = obj.SessionStatus;
   this.SessionModel.IsActive = obj.IsActive;
    };

  ngOnInit() {
    this.GetSchoolBranch();   
  }

 
  GetSchoolBranch() {
    this.lookupservice.GetLookupsList('BranchAll', '').subscribe((data: any) => {
      this.BranchList = data.LookupItems;
    });
  };

 

}




